import { createFileRoute } from '@tanstack/react-router';
import { FirstTimePasswordResetScreen } from '@/auth/FirstTimePasswordResetScreen';

export const Route = createFileRoute('/_auth/first-time-password-reset')({
  component: FirstTimePasswordResetScreen,
  validateSearch: (search: Record<string, unknown>): { email?: string } => ({
    // Carried over by the login form's redirect so the field arrives filled in.
    // Never trusted beyond prefilling a text box — the server looks the address
    // up itself.
    email: typeof search.email === 'string' ? search.email : undefined,
  }),
});
